// extracted by mini-css-extract-plugin
module.exports = {"arrowBottom":"navigationBar_arrowBottom__9KXRA"};